import React, {lazy} from "react";
import styles from './AdStructure.module.scss';
import {MDBCol, MDBContainer, MDBRow} from 'mdbreact';
import {IProduct} from 'data/interfaces/products';
import {If, Then} from "react-if";
import ShareButton from 'gui/pages/mainRouter/pages/ad/components/commons/shareButton/ShareButton';
import TopTitle from 'gui/pages/mainRouter/pages/ad/components/commons/adStructure/components/topTitle';
import SeoContainer from "data/redux/containers/seoContainer/SeoContainer";
import {PRODUCT_STATUS_PREVIEW} from 'data/redux/constants/productsConstants';
import AdNavigateBackContainer from "data/redux/containers/adNavigateBackContainer/AdNavigateBackContainer";
import classnames from 'classnames';
import {IOrder} from "data/interfaces/orders";
const AdminControlContainer = lazy(() => import(/* webpackChunkName: "AdminControlContainer" , webpackMode:'lazy' */ 'data/redux/containers/adminControlContainer/AdminControlContainer'));


export interface IAdStructure {
  product?: IProduct;
  order?: IOrder;
  isProductOwner?: boolean;
  isOrderOwner?: boolean;
  isAdmin?: boolean;
  title?: any;
  cards?: any;
  rightSideCard?: any;
  bottomCard?: any;
  isClickedPurchase?: boolean;
  ref?: any;
  loading?: boolean;
}

const AdStructure = (props: IAdStructure) => {
  return props.product.status === PRODUCT_STATUS_PREVIEW ? (props.cards) : (
    <If condition={props.loading || !isNaN(props.product.id)}>
      <Then>{() => <MDBContainer
        ref={props.ref}
        className={classnames({
          buyer: props.isOrderOwner,
          seller: props.isProductOwner,
          [`product-id-${props.product.id}`]: true,
          [`product-status-${props.product.status}`]: true,
        })} fluid>
        <SeoContainer
          preProcess={{
            "productName": props.title,
            "productDescription": "",
          }}
        />
        <MDBRow className={'hideWhen767'}>
          <MDBCol className={styles.topRow} xs="12" sm="8" md="9" lg="9">
            <TopTitle loading={props.loading}>
              {props.title}
            </TopTitle>
          </MDBCol>
          <MDBCol xs="12" sm="12" md="3" lg="3">
            <ShareButton product={props.product} loading={props.loading}/>
          </MDBCol>
        </MDBRow>
        <MDBRow className={styles.navigateBackRow}>
          <MDBCol>
            <AdNavigateBackContainer product={props.product}
                                     isClickedPurchase={props.isClickedPurchase}
                                     isProductOwner={props.isProductOwner}
                                     isOrderOwner={props.isOrderOwner}
                                     loading={props.loading}/>
          </MDBCol>
        </MDBRow>
        <MDBRow className={styles.secondRow}>
          <MDBCol md="4" lg="4">
            {props.rightSideCard}
          </MDBCol>
          <MDBCol md="8" lg="8">
            {props.cards}
            <If condition={props.bottomCard !== null}>
              <Then>
                {props.bottomCard}
              </Then>
            </If>
            {props.isAdmin ? <AdminControlContainer/> : null}
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      }
      </Then>
    </If>
  );
};

AdStructure.defaultProps = {
  title: '',
  product: {},
  isProductOwner: false,
  isOrderOwner: false,
  purchaseForm: null,
  rightSideCard: null,
  bottomCard: null,
};

export default AdStructure;
